import { render, staticRenderFns } from "./solicitacao.vue?vue&type=template&id=43050dc6&scoped=true&"
import script from "./solicitacao.vue?vue&type=script&lang=js&"
export * from "./solicitacao.vue?vue&type=script&lang=js&"
import style0 from "./solicitacao.vue?vue&type=style&index=0&id=43050dc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43050dc6",
  null
  
)

export default component.exports